import React, { useState, useRef, useEffect } from 'react';
import exact from 'prop-types-exact';
import dayJS from 'dayjs';
import { DragDropContext, Droppable, Draggable } from 'react-beautiful-dnd';
import { CircularProgress, Paper } from '@material-ui/core';
import DragHandleIcon from '@material-ui/icons/DragHandleOutlined';
import AutorenewIcon from '@material-ui/icons/Autorenew';
import AccessTimeIcon from '@material-ui/icons/AccessTime';
import { DAY_JS_DATE_FORMATS } from '../../utils/constants';
import {
  UploadFilesClinicModal,
  ADD_NEW_COLLECTION_KEY,
} from './UploadFilesClinicModal';
import { CollectionModal } from './CollectionModal';
import { DeleteResourceModal } from './DeleteResourceModal';
import { DeleteArticleModal } from './DeleteArticleModal';
import { FileListItem } from './FileListItem';
import { VideoPreviewModal } from './VideoPreviewModal';
import { EnableCustomersModal } from './EnableCustomersModal';
import { TooltipWrapper } from '../../Core/Components/TooltipWrapper/TooltipWrapper';
import { useFirebaseDB } from '../../Core/hooks/useFirebaseDB';
import addBookImg from './assets/add-book.png';
import addToCollectionImg from './assets/add-to-collection.png';
import styles from './UploadFilesClinic.scss';

const initialValue = Symbol('iv');

const MAX_FILE_SIZE = 750;

const CustomContentLogger = new MyEventWrapper('content_clinics');

const UploadFilesClinicBase = () => {
  const [
    clinicResourcesMap,
    // eslint-disable-next-line no-unused-vars
    setClinicResourcesMap,
    pushClinicResourcesMap,
  ] = useFirebaseDB({
    path: `lago/educational/clinics/${sessionStorage.userId}/clinicResourcesMap`,
    initialValue,
    defaultValue: useRef({}).current,
  });

  const [clinicResourcesData, setClinicResourcesData] = useFirebaseDB({
    path: `lago/educational/clinics/${sessionStorage.userId}/resources/drafts`,
    initialValue,
    defaultValue: useRef({}).current,
  });

  const [clinicResourcesDataPublished] = useFirebaseDB({
    path: `lago/educational/clinics/${sessionStorage.userId}/resources/published`,
    initialValue,
    defaultValue: useRef({}).current,
  });

  const [lastPublish, setLastPublish] = useFirebaseDB({
    path: `lago/educational/clinics/${sessionStorage.userId}/lastPublish`,
    initialValue,
    defaultValue: useRef('').current,
  });

  const [customClinicContentAvailable] = useFirebaseDB({
    path: `clinicConfig/appFeaturesConfig/${sessionStorage.userId}/clinicFeatureDefaults/customContent/isEnabled`,
    onceListener: true,
    initialValue,
  });

  const [unpublishedReorder, setUnpublishedReorder] = useFirebaseDB({
    path: `lago/educational/clinics/${sessionStorage.userId}/unpublishedReorder`,
    initialValue,
    defaultValue: useRef(false).current,
  });

  const [usersList] = useFirebaseDB({
    path: `clinicPatients/${sessionStorage.userId}`,
    defaultValue: useRef(0).current,
    initialValue,
  });

  const [isUploadModalOpen, setIsUploadModalOpen] = useState(false);
  const [selectedFile, setSelectedFile] = useState(null);
  const [categoryInput, setCategoryInput] = useState('');
  const [titleInput, setTitleInput] = useState('');
  const [titleInputError, setTitleInputError] = useState(false);
  const [selectedCategoryError, setSelectedCategoryError] = useState(false);
  const [isLoadingUploadFile, setIsLoadingUploadFile] = useState(false);
  const [editResourceId, setEditResourceId] = useState('');
  const [editResourceText, setEditResourceText] = useState('');
  const [articleToEdit, setArticleToEdit] = useState('');
  const [resourceOfArticleToEdit, setResourceOfArticleToEdit] = useState('');
  const [isComponentReadyToRender, setIsComponentReadyToRender] = useState(
    false
  );
  const [isCollectionModalOpen, setisCollectionModalOpen] = useState(false);
  const [collectionTitleInput, setCollectionTitleInput] = useState('');
  const [selectedCategory, setSelectedCategory] = useState('');
  const [resourceToDelete, setResourceToDelete] = useState('');
  const [articleToDelete, setArticleToDelete] = useState('');
  const [resourceOfArticleToDelete, setResourceOfArticleToDelete] = useState(
    ''
  );
  const [
    numberOfUnpublishedArticles,
    setNumberOfUnpublishedArticles,
  ] = useState(0);
  const [
    numberOfUnpublishedResources,
    setNumberOfUnpublishedResources,
  ] = useState(0);
  const [fileActionMenuId, setFileActionMenuId] = useState('');
  const [anchorEl, setAnchorEl] = useState(null);
  const [selectedVidPrevUrl, setSelectedVidPrevUrl] = useState('');
  const [collectionMinHieght, setCollectionMinHieght] = useState(0);
  const [
    isShouldEnableCustomersModalOpen,
    setIsShouldEnableCustomersModalOpen,
  ] = useState(false);
  const [isLoadingEnableCoustomers, setIsLoadingEnableCoustomers] = useState(
    false
  );
  const [isLoadingPublish, setIsLoadingPublish] = useState(false);
  const [filteredUsersList, setFilteredUsersList] = useState([]);
  const [filteredUsersList2, setFilteredUsersList2] = useState([]);
  const [isEnabledAllUsresPerformed, setIsEnabledAllUsresPerformed] = useState(
    false
  );

  useEffect(() => {
    if (usersList !== initialValue) {
      const filteredUsersListToSHow = Object.keys(usersList).filter(
        userId =>
          !usersList[userId].archived &&
          !usersList[userId].userInfo?.clinicianSetUpRequired &&
          usersList[userId].enableResources
      );
      setFilteredUsersList(filteredUsersListToSHow);
      const filteredUsersListToSHow2 = Object.keys(usersList).filter(
        userId =>
          usersList[userId].customClinicContentEnabled &&
          usersList[userId].enableResources
      );
      setFilteredUsersList2(filteredUsersListToSHow2);
    }
  }, [usersList]);

  useEffect(() => {
    if (
      clinicResourcesMap !== initialValue &&
      clinicResourcesData !== initialValue &&
      lastPublish !== initialValue &&
      customClinicContentAvailable !== initialValue
    ) {
      setIsComponentReadyToRender(true);
    }
  }, [
    clinicResourcesMap,
    clinicResourcesData,
    lastPublish,
    customClinicContentAvailable,
  ]);

  useEffect(() => {
    let counter = 0;
    let collectionCounter = 0;
    Object.keys(clinicResourcesData).forEach(resourceKey => {
      if (!clinicResourcesData[resourceKey].isPublished) {
        collectionCounter += 1;
      }
      if (clinicResourcesData[resourceKey].articles) {
        Object.keys(clinicResourcesData[resourceKey].articles).forEach(
          articleId => {
            if (
              !clinicResourcesData[resourceKey].articles[articleId].isPublished
            ) {
              counter += 1;
            }
          }
        );
      }
    });

    Object.keys(clinicResourcesDataPublished).forEach(resourceKey => {
      if (!clinicResourcesData[resourceKey]) {
        collectionCounter += 1;
      }
      if (
        clinicResourcesDataPublished[resourceKey] &&
        clinicResourcesDataPublished[resourceKey].articles
      ) {
        Object.keys(clinicResourcesDataPublished[resourceKey].articles).forEach(
          articleId => {
            if (
              !clinicResourcesData[resourceKey] ||
              !clinicResourcesData[resourceKey].articles ||
              !clinicResourcesData[resourceKey].articles[articleId]
            ) {
              counter += 1;
            }
          }
        );
      }
    });

    setNumberOfUnpublishedArticles(counter);
    setNumberOfUnpublishedResources(collectionCounter);
    setCollectionMinHieght(Object.keys(clinicResourcesData).length * 300);
  });

  const stringToNumberSum = str => {
    return Array.from(str)
      .map(char => char.charCodeAt(0))
      .reduce((sum, code) => sum + code, 0);
  };

  const resetState = () => {
    setIsUploadModalOpen(false);
    setSelectedFile(null);
    setCategoryInput('');
    setSelectedCategory('');
    setTitleInput('');
    setIsLoadingUploadFile(false);
    setSelectedCategoryError(false);
    setArticleToEdit('');
    setResourceOfArticleToEdit('');
    setTitleInputError(false);
    setSelectedCategoryError(false);
    setFileActionMenuId(null);
  };

  const getVideoDuration = async file => {
    try {
      const url = URL.createObjectURL(file);
      const video = document.createElement('video');

      return new Promise(resolve => {
        video.preload = 'metadata';
        video.src = url;

        video.onloadedmetadata = () => {
          URL.revokeObjectURL(url);
          resolve(video.duration); // duration in seconds
        };

        video.onerror = () => {
          URL.revokeObjectURL(url);
          resolve(0);
        };
      });
    } catch {
      return 0;
    }
  };

  const onInputFileChange = event => {
    if (event.target.files.length) {
      const [file] = event.target.files;

      const validTypes = ['application/pdf', 'video/mp4'];

      if (!validTypes.includes(file.type)) {
        // eslint-disable-next-line no-param-reassign
        event.target.value = ''; // Clear the input
        showNotification(
          'danger',
          'Invalid file type. Please upload a video or a PDF file.'
        );
        return;
      }
      if (file.size / 1024 / 1024 > MAX_FILE_SIZE) {
        // eslint-disable-next-line no-param-reassign
        event.target.value = ''; // Clear the input
        showNotification('danger', 'Maximum file size is 750MB.');
        return;
      }
      setSelectedFile(file);
    }
  };

  const validateFields = () => {
    let isError = false;
    if (
      !titleInput.trim() ||
      !selectedCategory ||
      (selectedCategory === ADD_NEW_COLLECTION_KEY && !categoryInput)
    ) {
      if (!titleInput.trim()) {
        setTitleInputError(true);
      }
      if (
        !selectedCategory ||
        (selectedCategory === ADD_NEW_COLLECTION_KEY && !categoryInput)
      ) {
        setSelectedCategoryError(true);
      }
      isError = true;
    }
    return isError;
  };

  const onDeleteArticle = async (resourceId, articleId) => {
    const remainingEntries = Object.entries(
      clinicResourcesData[resourceId].articles
    )
      .filter(([id]) => id !== articleId)
      .sort(([, a], [, b]) => a.index - b.index); // sort ascending

    const articlesCopy = { ...clinicResourcesData[resourceId].articles };

    remainingEntries.forEach(([id, resource], newIndex) => {
      articlesCopy[id] = {
        ...resource,
        index: newIndex,
      };
    });

    await database
      .ref(
        `lago/educational/clinics/${sessionStorage.userId}/resources/drafts/${resourceId}/articles`
      )
      .set(articlesCopy);
    database
      .ref(`lago/educational/clinics/${sessionStorage.userId}/resources/drafts`)
      .child(resourceId)
      .child('articles')
      .child(articleId)
      .set(null);
    setArticleToDelete('');
    setResourceOfArticleToDelete('');
  };

  const getVideoThumbnailFileUrl = (videoFile, filename = 'thumbnail.png') => {
    return new Promise((resolve, reject) => {
      const video = document.createElement('video');
      video.preload = 'metadata';
      video.src = URL.createObjectURL(videoFile);
      video.muted = true;
      video.playsInline = true;

      video.addEventListener('loadeddata', () => {
        video.currentTime = 0.1;
      });

      video.addEventListener('seeked', () => {
        const canvas = document.createElement('canvas');
        canvas.width = video.videoWidth;
        canvas.height = video.videoHeight;
        const ctx = canvas.getContext('2d');
        ctx.drawImage(video, 0, 0, canvas.width, canvas.height);

        canvas.toBlob(blob => {
          if (!blob) {
            reject(new Error('Could not convert canvas to Blob.'));
            return;
          }
          // eslint-disable-next-line no-undef
          const thumbnailFile = new File([blob], filename, {
            type: 'image/png',
          });
          URL.revokeObjectURL(video.src);
          const thumbnailId = Math.random()
            .toString(36)
            .substring(7);
          const path = `lago/clinics/${sessionStorage.userId}/thumbnails/${thumbnailId}`;
          const storage = window.firebase.storage();
          const thumbnailRef = storage.ref(path);
          try {
            thumbnailRef.put(thumbnailFile).then(() => {
              thumbnailRef.getDownloadURL().then(async res => {
                resolve(res);
              });
            });
          } catch (e) {
            showNotification(('danger', e));
          }
        }, 'image/png');
      });

      video.addEventListener('error', e => {
        reject(new Error(`Failed to load video. ${e}`));
      });
    });
  };

  const updateFileUrlIfNeeded = async (path, screenId, articleCopyObj) => {
    if (selectedFile) {
      const fileType = selectedFile.type.includes('video') ? 'vid' : 'pdf';

      setIsLoadingUploadFile(true);
      const videoId = Math.random()
        .toString(36)
        .substring(7);
      const storagePath = `lago/clinics/${sessionStorage.userId}/${videoId}`;
      const storage = window.firebase.storage();
      const videoRef = storage.ref(storagePath);
      try {
        await videoRef.put(selectedFile);
        videoRef.getDownloadURL().then(async res => {
          const variantIdData = await database
            .ref(`/lago/educational/defaults/screens/${screenId}/variants`)
            .once('value')
            .then(snapshot => snapshot.val());
          // eslint-disable-next-line prefer-destructuring
          const variantId = Object.keys(variantIdData)[0];
          const screensDatabaseRef = database.ref(
            `/lago/educational/defaults/screens/${screenId}`
          );
          const durationInSeconds =
            fileType === 'vid' ? await getVideoDuration(selectedFile) : 0;
          const videoThumbnailFileUrl =
            fileType === 'vid'
              ? await getVideoThumbnailFileUrl(selectedFile)
              : '';
          screensDatabaseRef.set({
            estimatedMins: durationInSeconds / 60,
            lastEdited: Date.now(),
            variants: {
              [variantId]: {
                dateAdded: Date.now(),
                estimatedMins: durationInSeconds / 60,
                screenType: fileType,
                title: {
                  en: titleInput,
                },
                variantConfig: {
                  isDefaultVariant: true,
                  variantTitle: 'default',
                },
                vidUrl:
                  fileType === 'vid'
                    ? {
                        en: res,
                      }
                    : null,
                pdfUrl:
                  fileType === 'pdf'
                    ? {
                        en: res,
                      }
                    : null,
              },
            },
          });
          const articleCopy = { ...articleCopyObj };
          articleCopy.vidUrl = fileType === 'vid' ? { en: res } : null;
          articleCopy.pdfUrl = fileType === 'pdf' ? { en: res } : null;
          articleCopy.screenType = fileType;
          articleCopy.storageFileId = videoId;
          articleCopy.fileSize = selectedFile.size;
          articleCopy.estimatedMins = durationInSeconds / 60;
          articleCopy.img = videoThumbnailFileUrl;
          await database.ref(path).set(articleCopy);
          setIsLoadingUploadFile(false);
        });
      } catch (e) {
        setIsUploadModalOpen(false);
        setIsLoadingUploadFile(false);
        showNotification('danger', e);
      }
    }
  };

  const onSaveEditedArticle = async () => {
    if (validateFields()) {
      return;
    }
    setIsLoadingUploadFile(true);

    const articleCopy = {
      ...clinicResourcesData[resourceOfArticleToEdit].articles[articleToEdit],
    };
    articleCopy.lastEdited = Date.now();
    articleCopy.title.en = titleInput;
    articleCopy.isPublished = false;

    const category =
      selectedCategory === ADD_NEW_COLLECTION_KEY
        ? categoryInput
        : selectedCategory;

    // If the catgory didnt change on edit
    const isSameCategory =
      category === clinicResourcesData[resourceOfArticleToEdit].resourceName.en;

    if (isSameCategory) {
      const articleToEditDatabaseRef = database.ref(
        `/lago/educational/clinics/${sessionStorage.userId}/resources/drafts/${resourceOfArticleToEdit}/articles/${articleToEdit}`
      );
      articleToEditDatabaseRef.set(articleCopy).then(async () => {
        await updateFileUrlIfNeeded(
          `/lago/educational/clinics/${sessionStorage.userId}/resources/drafts/${resourceOfArticleToEdit}/articles/${articleToEdit}`,
          Object.keys(articleCopy.screens)[0],
          { ...articleCopy }
        );
        resetState();
      });
    } else {
      onDeleteArticle(resourceOfArticleToEdit, articleToEdit);

      const isExsitingCategory = Object.keys(clinicResourcesMap).find(
        key => clinicResourcesMap[key] === category
      );
      const categoryKey =
        isExsitingCategory || pushClinicResourcesMap(category).key;

      if (isExsitingCategory) {
        const lagoClinicsDatabaseRef = database.ref(
          `/lago/educational/clinics/${sessionStorage.userId}/resources/drafts/${categoryKey}/articles`
        );
        lagoClinicsDatabaseRef.push(articleCopy).then(async res => {
          await updateFileUrlIfNeeded(
            `/lago/educational/clinics/${sessionStorage.userId}/resources/drafts/${categoryKey}/articles/${res.key}`,
            Object.keys(articleCopy.screens)[0],
            { ...articleCopy }
          );
          resetState();
        });
      } else {
        const articleId = Math.random()
          .toString(36)
          .substring(7);
        const lagoClinicsDatabaseRef = database.ref(
          `/lago/educational/clinics/${sessionStorage.userId}/resources/drafts/${categoryKey}`
        );
        lagoClinicsDatabaseRef
          .set({
            resourceName: {
              en: category,
            },
            articles: {
              [articleId]: articleCopy,
            },
            index: Object.keys(clinicResourcesMap).length,
            isEnabled: true,
          })
          .then(async () => {
            await updateFileUrlIfNeeded(
              `/lago/educational/clinics/${sessionStorage.userId}/resources/drafts/${categoryKey}/articles/${articleId}`,
              Object.keys(articleCopy.screens)[0],
              { ...articleCopy }
            );
            resetState();
          });
      }
    }
  };

  const onUploadArticle = async () => {
    if (validateFields()) {
      return;
    }
    const fileType = selectedFile.type.includes('video') ? 'vid' : 'pdf';
    setIsLoadingUploadFile(true);
    const category =
      selectedCategory === ADD_NEW_COLLECTION_KEY
        ? categoryInput
        : selectedCategory;
    const isExsitingCategory = Object.keys(clinicResourcesMap).find(
      key => clinicResourcesMap[key] === category
    );
    const categoryKey =
      isExsitingCategory || pushClinicResourcesMap(category).key;

    const videoId = Math.random()
      .toString(36)
      .substring(7);
    const path = `lago/clinics/${sessionStorage.userId}/${videoId}`;
    const storage = window.firebase.storage();
    const videoRef = storage.ref(path);
    try {
      await videoRef.put(selectedFile);
      videoRef
        .getDownloadURL()
        .then(async res => {
          const varinatId = Math.random()
            .toString(36)
            .substring(7);
          const screensDatabaseRef = database.ref(
            '/lago/educational/defaults/screens'
          );
          const durationInSeconds =
            fileType === 'vid' ? await getVideoDuration(selectedFile) : 0;

          const videoThumbnailFileUrl =
            fileType === 'vid'
              ? await getVideoThumbnailFileUrl(selectedFile)
              : '';

          screensDatabaseRef
            .push({
              estimatedMins: durationInSeconds / 60,
              lastEdited: Date.now(),
              variants: {
                [varinatId]: {
                  dateAdded: Date.now(),
                  estimatedMins: durationInSeconds / 60,
                  screenType: fileType,
                  title: {
                    en: titleInput,
                  },
                  variantConfig: {
                    isDefaultVariant: true,
                    variantTitle: 'default',
                  },
                  vidUrl:
                    fileType === 'vid'
                      ? {
                          en: res,
                        }
                      : null,
                  pdfUrl:
                    fileType === 'pdf'
                      ? {
                          en: res,
                        }
                      : null,
                },
              },
            })
            .then(result => {
              const screenKey = result.key;
              if (isExsitingCategory) {
                const lagoClinicsDatabaseRef = database.ref(
                  `/lago/educational/clinics/${sessionStorage.userId}/resources/drafts/${categoryKey}/articles`
                );
                lagoClinicsDatabaseRef
                  .push({
                    title: {
                      en: titleInput,
                    },
                    screens: {
                      [screenKey]: 0,
                    },
                    lastEdited: Date.now(),
                    isEnabled: true,
                    categoryIds: ['custom_category_id'],
                    vidUrl:
                      fileType === 'vid'
                        ? {
                            en: res,
                          }
                        : null,
                    pdfUrl:
                      fileType === 'pdf'
                        ? {
                            en: res,
                          }
                        : null,
                    screenType: fileType,
                    storageFileId: videoId,
                    fileSize: selectedFile.size,
                    index: clinicResourcesData[categoryKey].articles
                      ? Object.keys(clinicResourcesData[categoryKey].articles)
                          .length
                      : 0,
                    isPublished: false,
                    estimatedMins: durationInSeconds / 60,
                    img: videoThumbnailFileUrl,
                    gradientColorIndex: stringToNumberSum(result.key) % 3,
                  })
                  .then(() => {
                    CustomContentLogger.log('create_resource', {
                      title: titleInput,
                      collection:
                        clinicResourcesData[categoryKey].resourceName.en,
                      file_type: fileType,
                      file_path: path,
                    });
                    resetState();
                  });
              } else {
                const articleId = Math.random()
                  .toString(36)
                  .substring(7);
                const lagoClinicsDatabaseRef = database.ref(
                  `/lago/educational/clinics/${sessionStorage.userId}/resources/drafts/${categoryKey}`
                );
                lagoClinicsDatabaseRef
                  .set({
                    resourceName: {
                      en: category,
                    },
                    articles: {
                      [articleId]: {
                        title: {
                          en: titleInput,
                        },
                        screens: {
                          [screenKey]: 0,
                        },
                        lastEdited: Date.now(),
                        isEnabled: true,
                        categoryIds: ['custom_category_id'],
                        vidUrl:
                          fileType === 'vid'
                            ? {
                                en: res,
                              }
                            : null,
                        pdfUrl:
                          fileType === 'pdf'
                            ? {
                                en: res,
                              }
                            : null,
                        screenType: fileType,
                        storageFileId: videoId,
                        fileSize: selectedFile.size,
                        index: 0,
                        estimatedMins: durationInSeconds / 60,
                      },
                    },
                    index: Object.keys(clinicResourcesMap).length,
                    isEnabled: true,
                  })
                  .then(() => {
                    CustomContentLogger.log('create_resource', {
                      title: titleInput,
                      collection: category,
                      file_type: fileType,
                      file_path: path,
                    });
                    resetState();
                  });
              }
            })
            .catch(e => {
              setIsUploadModalOpen(false);
              setIsLoadingUploadFile(false);
              showNotification('danger', e);
            });
          // setSelctedImage(res);
        })
        .catch(error => {
          setIsUploadModalOpen(false);
          setIsLoadingUploadFile(false);
          showNotification('danger', error);
        });
    } catch (err) {
      setIsUploadModalOpen(false);
      setIsLoadingUploadFile(false);
      showNotification('danger', err);
    }
  };

  const onCancelUpload = () => {
    resetState();
  };

  const createResource = () => {
    database
      .ref(`lago/educational/clinics/${sessionStorage.userId}/resources/drafts`)
      .push({
        index: clinicResourcesData
          ? Object.keys(clinicResourcesData).length
          : 0,
        isEnabled: true,
        resourceName: {
          en: collectionTitleInput,
        },
        isPublished: false,
      })
      .then(result => {
        const resourceId = result.key;
        database
          .ref(
            `lago/educational/clinics/${sessionStorage.userId}/clinicResourcesMap`
          )
          .child(resourceId)
          .set(collectionTitleInput)
          .then(() => {
            CustomContentLogger.log('create_collection', {
              name: collectionTitleInput,
            });
            setCollectionTitleInput('');
            setisCollectionModalOpen(false);
          });
      });
  };

  const onDeleteResource = resourceId => {
    const remainingEntries = Object.entries(clinicResourcesData)
      .filter(([id]) => id !== resourceId)
      .sort(([, a], [, b]) => a.index - b.index); // sort ascending

    const resourcesCopy = { ...clinicResourcesData };

    remainingEntries.forEach(([id, resource], newIndex) => {
      resourcesCopy[id] = {
        ...resource,
        index: newIndex,
      };
    });

    setClinicResourcesData(resourcesCopy);
    database
      .ref(`lago/educational/clinics/${sessionStorage.userId}/resources/drafts`)
      .child(resourceId)
      .set(null);
    database
      .ref(
        `lago/educational/clinics/${sessionStorage.userId}/clinicResourcesMap`
      )
      .child(resourceId)
      .set(null);
    setResourceToDelete('');
  };

  const onToggleResource = resourceId => {
    if (!clinicResourcesData[resourceId].articles) {
      return;
    }
    database
      .ref(`lago/educational/clinics/${sessionStorage.userId}/resources/drafts`)
      .child(resourceId)
      .child('isEnabled')
      .set(!clinicResourcesData[resourceId].isEnabled);

    database
      .ref(`lago/educational/clinics/${sessionStorage.userId}/resources/drafts`)
      .child(resourceId)
      .child('isPublished')
      .set(false);
    CustomContentLogger.log('collection_action', {
      action: clinicResourcesData[resourceId].isEnabled
        ? 'invisible'
        : 'visible',
      collectionId: resourceId,
    });
  };

  const onSaveEditResource = async resourceId => {
    if (!editResourceText.trim()) {
      return;
    }
    await database
      .ref(`lago/educational/clinics/${sessionStorage.userId}/resources/drafts`)
      .child(resourceId)
      .child('resourceName')
      .child('en')
      .set(editResourceText);
    await database
      .ref(`lago/educational/clinics/${sessionStorage.userId}/resources/drafts`)
      .child(resourceId)
      .child('isPublished')
      .set(false);
    await database
      .ref(
        `lago/educational/clinics/${sessionStorage.userId}/clinicResourcesMap`
      )
      .child(resourceId)
      .set(editResourceText);

    setEditResourceId('');
    setEditResourceText('');
  };

  const onToggleArticle = (resourceId, articleId) => {
    database
      .ref(`lago/educational/clinics/${sessionStorage.userId}/resources/drafts`)
      .child(resourceId)
      .child('articles')
      .child(articleId)
      .child('isEnabled')
      .set(!clinicResourcesData[resourceId].articles[articleId].isEnabled);
    database
      .ref(`lago/educational/clinics/${sessionStorage.userId}/resources/drafts`)
      .child(resourceId)
      .child('articles')
      .child(articleId)
      .child('isPublished')
      .set(false);
    CustomContentLogger.log('resource_action', {
      action: clinicResourcesData[resourceId].articles[articleId].isEnabled
        ? 'invisible'
        : 'visible',
      collectionId: resourceId,
      resourceId: articleId,
    });
  };

  const onEditArticle = (resourceId, articleId) => {
    setIsUploadModalOpen(true);
    setArticleToEdit(articleId);
    setResourceOfArticleToEdit(resourceId);
    setTitleInput(clinicResourcesData[resourceId].articles[articleId].title.en);
    setSelectedCategory(clinicResourcesData[resourceId].resourceName.en);
  };

  const numOfChanges = () => {
    return (
      numberOfUnpublishedArticles +
      numberOfUnpublishedResources +
      (unpublishedReorder ? 1 : 0)
    );
  };

  const calcNumOfChanges = () => {
    const numberOfChanges = numOfChanges();
    if (numberOfChanges) {
      return `${numberOfChanges} unpublished changes`;
    }
    return 'No changes';
  };

  const enableAllUsers = async () => {
    const path = `lago/educational/clinics/${sessionStorage.userId}/invokeEnableCustomContentForAllUsers`;
    await database.ref(path).set(true);
  };

  const onPublishClicked = () => {
    if (!numOfChanges()) {
      return;
    }
    const dataCopy = { ...clinicResourcesData };
    if (!clinicResourcesData) {
      return;
    }
    Object.keys(dataCopy).forEach(resourceKey => {
      dataCopy[resourceKey].isPublished = true;
      if (dataCopy[resourceKey].articles) {
        Object.keys(dataCopy[resourceKey].articles).forEach(articleId => {
          dataCopy[resourceKey].articles[articleId].isPublished = true;
        });
      }
    });
    database
      .ref(
        `lago/educational/clinics/${sessionStorage.userId}/resources/published`
      )
      .set(dataCopy);
    setLastPublish(Date.now());
    setClinicResourcesData(dataCopy);
    CustomContentLogger.log('publish');
    setUnpublishedReorder(false);
  };

  const orderResourceIndexes = (sourceIndex, destinationIndex) => {
    const orderedIds = Object.keys(clinicResourcesData).sort(
      (a, b) => clinicResourcesData[a].index - clinicResourcesData[b].index
    );
    const [movedId] = orderedIds.splice(sourceIndex, 1);
    orderedIds.splice(destinationIndex, 0, movedId);
    const resourcesCopy = { ...clinicResourcesData };
    orderedIds.forEach((id, i) => {
      resourcesCopy[id].index = i;
    });
    setClinicResourcesData(resourcesCopy);
  };

  const onResourcesDragEnd = dragResult => {
    if (!dragResult.destination) return;
    orderResourceIndexes(dragResult.source.index, dragResult.destination.index);
    CustomContentLogger.log('re_order_collections');
    setUnpublishedReorder(true);
  };

  const orderArticleIndexes = (sourceIndex, destinationIndex, resourceId) => {
    const articlesObject = clinicResourcesData[resourceId].articles;
    const orderedIds = Object.keys(articlesObject).sort(
      (a, b) => articlesObject[a].index - articlesObject[b].index
    );
    const [movedId] = orderedIds.splice(sourceIndex, 1);
    orderedIds.splice(destinationIndex, 0, movedId);
    const articlesCopy = { ...articlesObject };
    orderedIds.forEach((id, i) => {
      articlesCopy[id].index = i;
    });
    database
      .ref(
        `lago/educational/clinics/${sessionStorage.userId}/resources/drafts/${resourceId}/articles`
      )
      .set(articlesCopy);
    CustomContentLogger.log('re_order_resources');
  };

  const onArticleDragEnd = (dragResult, resourceId) => {
    if (!dragResult.destination) return;
    orderArticleIndexes(
      dragResult.source.index,
      dragResult.destination.index,
      resourceId
    );
    CustomContentLogger.log('re_order_articles', { collectionId: resourceId });
    setUnpublishedReorder(true);
  };

  if (!isComponentReadyToRender) {
    return <CircularProgress style={{ marginTop: 40, marginLeft: '50%' }} />;
  }

  if (!customClinicContentAvailable) {
    return (
      <div className={styles.team_member_container}>
        <Paper>
          <div
            style={{
              display: 'flex',
              flexDirection: 'column',
              justifyContent: 'center',
              alignItems: 'center',
            }}
          >
            <div style={{ fontWeight: 'bold', marginBottom: 10 }}>
              You don’t have permission to access Custom content
            </div>
          </div>
        </Paper>
      </div>
    );
  }

  const orederResourcesIds = Object.keys(clinicResourcesData).sort(
    (a, b) => clinicResourcesData[a].index - clinicResourcesData[b].index
  );

  return (
    <div className={styles.container}>
      <div className={styles.page_container}>
        <Paper style={{ padding: 20, minHeight: collectionMinHieght }}>
          <div className={styles.header_container}>
            <div>
              <div className={styles.page_title}>Manage my content</div>
              <div className={styles.line_item}>
                Manage educational content your clients will access through the
                explore tab on the Myndlift app
              </div>
              <div className={styles.line_container}>
                <div className={styles.actions_container}>
                  <div
                    className={styles.button}
                    onClick={() => {
                      setisCollectionModalOpen(true);
                    }}
                    style={{ marginRight: 10 }}
                  >
                    <img
                      src={addToCollectionImg}
                      style={{ marginRight: 10, width: 16, height: 16 }}
                    />
                    NEW COLLECTION
                  </div>
                  <div
                    className={styles.button}
                    onClick={() => {
                      setIsUploadModalOpen(true);
                    }}
                  >
                    <img
                      src={addBookImg}
                      style={{ marginRight: 10, width: 16, height: 16 }}
                    />
                    NEW RESOURCE
                  </div>
                </div>
              </div>
            </div>
            <div>
              <div
                className={styles.button}
                style={
                  numOfChanges()
                    ? { backgroundColor: '#4BE0D0' }
                    : { backgroundColor: '#DBDBDB', cursor: 'auto', opacity: 1 }
                }
                onClick={async () => {
                  if (!numOfChanges()) {
                    return;
                  }
                  setIsLoadingPublish(true);
                  if (lastPublish) {
                    onPublishClicked();
                    setIsShouldEnableCustomersModalOpen(true);
                  } else {
                    setIsShouldEnableCustomersModalOpen(true);
                  }
                  setIsLoadingPublish(false);
                }}
              >
                {isLoadingPublish ? <CircularProgress size={14} /> : 'PUBLISH'}
              </div>
              {!orederResourcesIds.length ? null : (
                <div
                  style={{
                    display: 'flex',
                    flexDirection: 'column',
                    whiteSpace: 'nowrap',
                  }}
                >
                  {lastPublish ? (
                    <div
                      style={{
                        width: 150,
                        marginBottom: 10,
                        display: 'flex',
                        alignItems: 'center',
                        fontSize: 12,
                      }}
                    >
                      <AccessTimeIcon
                        style={{ marginRight: 10, fontSize: 12 }}
                      />
                      {dayJS(lastPublish).format(
                        DAY_JS_DATE_FORMATS.americanWithTime
                      )}{' '}
                    </div>
                  ) : null}
                  <div
                    style={{
                      width: 150,
                      marginBottom: 10,
                      display: 'flex',
                      alignItems: 'center',
                      fontSize: 12,
                    }}
                  >
                    <AutorenewIcon style={{ marginRight: 10, fontSize: 12 }} />
                    {calcNumOfChanges()}
                  </div>
                </div>
              )}
            </div>
          </div>
          {orederResourcesIds.length ? (
            <div style={{ fontSize: 14, color: '#000' }}>
              Resource collections
            </div>
          ) : null}
          {orederResourcesIds.length ? (
            <DragDropContext onDragEnd={onResourcesDragEnd}>
              <Droppable droppableId="resource_droppable">
                {provided => (
                  <div ref={provided.innerRef}>
                    {orederResourcesIds.map((resourceId, index) => {
                      return (
                        <Draggable
                          key={resourceId}
                          draggableId={resourceId}
                          index={index}
                          isDragDisabled={orederResourcesIds.length < 2}
                        >
                          {itemProvided => (
                            <div
                              ref={itemProvided.innerRef}
                              {...itemProvided.draggableProps}
                            >
                              <Paper
                                style={{
                                  padding: 5,
                                  marginTop: 40,
                                  minHeight: 150,
                                  paddingBottom: 40,
                                }}
                              >
                                <span
                                  {...itemProvided.dragHandleProps}
                                  style={{
                                    position: 'relative',
                                    top: 32,
                                    right: -20,
                                    visibility: editResourceId
                                      ? 'hidden'
                                      : 'visible',
                                  }}
                                >
                                  <TooltipWrapper
                                    title={
                                      orederResourcesIds.length < 2
                                        ? ''
                                        : 'Drag to change order of collections'
                                    }
                                    classes={{
                                      tooltip: styles.tooltip,
                                    }}
                                  >
                                    <DragHandleIcon
                                      style={{
                                        fontSize: 16,
                                        cursor:
                                          orederResourcesIds.length < 2
                                            ? 'auto'
                                            : 'grab',
                                      }}
                                    />
                                  </TooltipWrapper>
                                </span>
                                <FileListItem
                                  resourceId={resourceId}
                                  resource={clinicResourcesData[resourceId]}
                                  onEditResource={() => {
                                    setFileActionMenuId(null);
                                    setEditResourceId(resourceId);
                                    setEditResourceText(
                                      clinicResourcesData[resourceId]
                                        .resourceName.en
                                    );
                                  }}
                                  onDeleteResource={() => {
                                    setFileActionMenuId(null);
                                    setResourceToDelete(resourceId);
                                  }}
                                  onToggleResource={() => {
                                    setFileActionMenuId(null);
                                    onToggleResource(resourceId);
                                  }}
                                  editResourceId={editResourceId}
                                  editResourceText={editResourceText}
                                  setEditResourceText={setEditResourceText}
                                  onSaveEditResource={() => {
                                    CustomContentLogger.log(
                                      'collection_action',
                                      {
                                        action: 'edit',
                                        collectionId: resourceId,
                                      }
                                    );
                                    onSaveEditResource(resourceId);
                                  }}
                                  onCloseEditResource={() => {
                                    setEditResourceId('');
                                    setEditResourceText('');
                                  }}
                                  onDeleteArticle={articleId => {
                                    setResourceOfArticleToDelete(resourceId);
                                    setArticleToDelete(articleId);
                                  }}
                                  onToggleArticle={articleId => {
                                    onToggleArticle(resourceId, articleId);
                                  }}
                                  onEditArticle={articleId => {
                                    onEditArticle(resourceId, articleId);
                                  }}
                                  onArticleDragEnd={dragResult => {
                                    onArticleDragEnd(dragResult, resourceId);
                                  }}
                                  fileActionMenuId={fileActionMenuId}
                                  setFileActionMenuId={setFileActionMenuId}
                                  anchorEl={anchorEl}
                                  setAnchorEl={setAnchorEl}
                                  setSelectedVidPrevUrl={setSelectedVidPrevUrl}
                                  onAddResourceToCollection={() => {
                                    setSelectedCategory(
                                      clinicResourcesData[resourceId]
                                        .resourceName.en
                                    );
                                    setIsUploadModalOpen(true);
                                  }}
                                />
                              </Paper>
                            </div>
                          )}
                        </Draggable>
                      );
                    })}
                  </div>
                )}
              </Droppable>
            </DragDropContext>
          ) : (
            <div className={styles.empty_list_placeholder}>
              No files uploaded yet
            </div>
          )}
        </Paper>
      </div>

      <UploadFilesClinicModal
        isOpen={isUploadModalOpen}
        onSave={() => {
          if (articleToEdit) {
            CustomContentLogger.log('resource_action', {
              action: 'edit',
              collectionId: resourceOfArticleToEdit,
              resourceId: articleToEdit,
            });
            onSaveEditedArticle();
          } else {
            onUploadArticle();
          }
        }}
        onCancel={onCancelUpload}
        onClose={resetState}
        onInputFileChange={onInputFileChange}
        selectedFile={selectedFile}
        categoryInput={categoryInput}
        setCategoryInput={setCategoryInput}
        titleInput={titleInput}
        setTitleInput={setTitleInput}
        titleInputError={titleInputError}
        selectedCategoryError={selectedCategoryError}
        isLoadingUploadFile={isLoadingUploadFile}
        isModalEditMode={articleToEdit}
        resourcesNames={Object.values(clinicResourcesMap)}
        selectedCategory={selectedCategory}
        setSelectedCategory={setSelectedCategory}
        setTitleInputError={setTitleInputError}
        setSelectedCategoryError={setSelectedCategoryError}
      />
      <CollectionModal
        isOpen={isCollectionModalOpen}
        onSave={createResource}
        onCancel={() => {
          setisCollectionModalOpen(false);
          setCollectionTitleInput('');
        }}
        onClose={() => {
          setisCollectionModalOpen(false);
          setCollectionTitleInput('');
        }}
        titleInput={collectionTitleInput}
        setTitleInput={setCollectionTitleInput}
      />
      <DeleteResourceModal
        isOpen={!!resourceToDelete}
        onSave={() => {
          CustomContentLogger.log('collection_action', {
            action: 'delete',
            collectionId: resourceToDelete,
          });
          onDeleteResource(resourceToDelete);
        }}
        onClose={() => {
          setResourceToDelete('');
        }}
        isDeletable={
          clinicResourcesData[resourceToDelete] &&
          !clinicResourcesData[resourceToDelete].articles
        }
        collectionName={
          clinicResourcesData[resourceToDelete] &&
          clinicResourcesData[resourceToDelete].resourceName.en
        }
      />
      <DeleteArticleModal
        isOpen={!!articleToDelete}
        onSave={() => {
          CustomContentLogger.log('resource_action', {
            action: 'delete',
            collectionId: resourceOfArticleToDelete,
            resourceId: articleToDelete,
          });
          onDeleteArticle(resourceOfArticleToDelete, articleToDelete);
        }}
        onClose={() => {
          setArticleToDelete('');
          setResourceOfArticleToDelete('');
        }}
        articleName={
          clinicResourcesData[resourceOfArticleToDelete] &&
          clinicResourcesData[resourceOfArticleToDelete].articles &&
          clinicResourcesData[resourceOfArticleToDelete].articles[
            articleToDelete
          ] &&
          clinicResourcesData[resourceOfArticleToDelete].articles[
            articleToDelete
          ].title.en
        }
      />
      <VideoPreviewModal
        isOpen={!!selectedVidPrevUrl}
        onClose={() => {
          setSelectedVidPrevUrl('');
        }}
        vidUrl={selectedVidPrevUrl}
      />
      <EnableCustomersModal
        isOpen={isShouldEnableCustomersModalOpen}
        onClose={() => {
          if (isEnabledAllUsresPerformed) {
            setIsEnabledAllUsresPerformed(false);
          }
          setIsShouldEnableCustomersModalOpen(false);
        }}
        onConfirm={async val => {
          if (val === 'enable') {
            setIsLoadingEnableCoustomers(true);
            await enableAllUsers();
            setIsEnabledAllUsresPerformed(true);
            onPublishClicked();
            setIsLoadingEnableCoustomers(false);
          } else {
            onPublishClicked();
          }
        }}
        lastPublish={lastPublish}
        isLoadingEnableCoustomers={isLoadingEnableCoustomers}
        numberOfEnabledUsers={
          isEnabledAllUsresPerformed
            ? filteredUsersList.length
            : filteredUsersList2.length
        }
      />
    </div>
  );
};

UploadFilesClinicBase.propTypes = exact({});

export const UploadFilesClinic = React.memo(UploadFilesClinicBase);
UploadFilesClinic.displayName = 'UploadFilesClinic';
